<template>
    <div class="db-card" @click.stop="handleClickCard">
        <div
            class="heading"
            :style="`background-color:${getBackgroundColor(type)}`"
        >
            <div>{{ room }}</div>
            <div class="right">{{ period }}</div>
        </div>
        <div class="content">
            <span>
                <a :href="patientLink" @click.prevent>
                    {{ patientName }}
                </a>
                ({{ species }})
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "dashboard-card",
    props: {
        type: {
            type: String, // values: checking-in | checked-in | checking-out | checked-out
            required: true
        },
        room: {
            type: String,
            required: true
        },
        period: {
            type: String,
            required: true
        },
        species: {
            type: String,
            required: true
        },
        patientName: {
            type: String,
            required: true
        },
        patientLink: {
            type: String,
            required: true
        }
    },
    methods: {
        getBackgroundColor(type) {
            const map = {
                "checking-in": "#689ec9", // blue
                "checked-in": "#6ec564", // green (currently boarded)
                "checking-out": "#ee6e6d", // red
                "checked-out": "#b3b3b3" // grey
            };

            return map[type];
        },
        handleClickCard() {
            this.$emit("onclick");
        }
    }
};
</script>

<style scoped>
.db-card {
    border: 1px solid #d5d5d5;
    box-shadow: 1px 1px 5px 2px #ececec;
    border-radius: 5px;
    padding: 7px;
    margin: 5px 7px;
    margin-bottom: 15px;
    background-color: #fff;
    cursor: pointer;
    user-select: none;
}
.db-card[draggable="true"] {
    cursor: pointer;
}
.db-card:hover {
    box-shadow: 2px 4px 5px 2px #dfdfdf;
}
.heading {
    color: #fff;
    font-weight: bold;
    padding: 5px 10px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    display: grid;
    grid-template-columns: 1fr 1fr;
}
.heading .right {
    text-align: right;
}
.db-card .content {
    padding: 5px 10px;
}
</style>
